import { App, Col, InputNumber, Space, Typography } from "antd";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { queryDaysBlockChange } from "./queries";
import { usePostField } from "$components/RequiredAttributesField/queries";
import { useAuth } from "$context/AuthContextProvider";
const { Text } = Typography;

const queryKey = "daysBlockChange";
const attributeKey = "blocking_period";

const DaysBlockChangeField = ({ text }) => {
  const { notification } = App.useApp();
  const { municipalUtility: municipalId } = useAuth();
  const queryClient = useQueryClient();

  const { data: daysBlockChange } = useQuery(queryDaysBlockChange(municipalId));

  const mutationFn = usePostField(queryKey);

  return (
    <>
      <Col>
        <Text>{text}</Text>
      </Col>
      <Col>
        <Space align="center">
          <InputNumber
            controls={false}
            value={daysBlockChange}
            min={1}
            disabled={mutationFn.isPending}
            style={{
              width: 50,
            }}
            onPressEnter={(val) => {
              const { value: inputValue } = val.target;
              console.log(Number.isInteger(inputValue));
              if (Number.isInteger(Number(inputValue)) && inputValue > 0) {
                mutationFn.mutate(
                  { [attributeKey]: inputValue },
                  {
                    onSuccess: () => {
                      notification.success({
                        message: "Aktuallisierung war erfolgreich!",
                      });
                    },
                    onError: () => {
                      notification.error({
                        message: "Aktuallisierung ist fehlgeschlagen!",
                      });
                    },
                  }
                );
              } else {
                notification.error({
                  message: `Ungültiger Wert!`,
                });
                queryClient.invalidateQueries({
                  queryKey: [queryKey],
                });
              }
            }}
          />
        </Space>
      </Col>
    </>
  );
};

export default DaysBlockChangeField;
